import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoggingService {
    logError(error: Error | HttpErrorResponse) {
        // Console is the dev-only sink; in production it would leak error/PII payloads to the
        // browser console. Swap this for a real telemetry sink when one is wired.
        if (!environment.production) {
            console.error(error);
        }
    }
}
